interface IEnvironment {
  appName: string;
  clientId: string;
  baseUrl: string;
  domain: string;
}

export const environment: Readonly<IEnvironment> = {
  appName: "aseman",
  clientId: "clientId",
  baseUrl: "https://api.asemansoleh.com/api/panel/",
  domain: "https://api.asemansoleh.com/"
  // baseUrl: "https://localhost:5000/api/panel/",
  // domain:  "https://localhost:5000/"
};
